export const SITESETUP_SET_ASSIGN_LOADING = 'SITESETUP_SET_ASSIGN_LOADING';
export const SITESETUP_SET_ASSIGN_USER_DATA = 'SITESETUP_SET_ASSIGN_USER_DATA';
export const SITESETUP_CLEAR_ASSIGN_USER_DATA =
  'SITESETUP_CLEAR_ASSIGN_USER_DATA';
export const SITESETUP_UPDATE_ASSIGN_USER_DATA =
  'SITESETUP_UPDATE_ASSIGN_USER_DATA';
export const SITESETUP_CHECKALL_ASSIGN_USER_DATA =
  'SITESETUP_CHECKALL_ASSIGN_USER_DATA';
export const SITESETUP_SET_ASSIGN_CURRENT_SITE =
  'SITESETUP_SET_ASSIGN_CURRENT_SITE';
export const SITESETUP_UPDATE_IS_PAGE_ACCESSIBLE =
  'SITESETUP_UPDATE_IS_PAGE_ACCESSIBLE';



// WEBPACK FOOTER //
// ./src/pages/sitesetup/state/assignUsers/types.js